'use client'
import Link from 'next/link'
import { AIRPORT_DB } from './AirportCombobox'

export default function DealsOpenJaw({ isPaid, openJawPairs, origin, formatDealPrice }) {
  if (!isPaid) {
    return (
      <div className="mt-8 rounded-xl border border-teal-200 bg-gradient-to-br from-teal-50 to-cyan-50 p-5 shadow-sm">
        <div className="flex items-start gap-3">
          <span className="text-2xl shrink-0">🗺️</span>
          <div className="min-w-0 flex-1">
            <p className="text-sm font-semibold text-gray-900">Open-jaw trip suggestions</p>
            <p className="text-xs text-gray-600 mt-0.5">
              Combine two deals into a smart multi-city trip — fly into one city, travel overland, fly home from another.
            </p>
            <Link href="/pricing" className="mt-2 inline-block rounded-lg bg-teal-600 px-4 py-2 text-xs font-semibold text-white hover:bg-teal-700 transition-colors">
              Unlock with Plus →
            </Link>
          </div>
        </div>
      </div>
    )
  }

  if (!openJawPairs.length) return null

  return (
    <div className="mt-8">
      <h2 className="mb-3 text-sm font-bold uppercase tracking-wide text-gray-900">
        🗺️ Open-jaw combinations
        <span className="ml-2 text-xs font-normal normal-case tracking-normal text-gray-400">
          from {origin}
        </span>
      </h2>
      <ul className="space-y-2">
        {openJawPairs.map(({ dealA, dealB, combinedPrice, transportHint }, i) => (
          <li key={i}>
            <Link
              href={`/deals/${dealA.id}`}
              className="flex items-center justify-between rounded-xl border border-gray-100 bg-white p-4 shadow-sm hover:shadow-md hover:border-teal-200 transition-all"
            >
              <div className="min-w-0">
                <p className="text-sm font-semibold text-gray-900">
                  {AIRPORT_DB[dealA.destination]?.city ?? dealA.destination}
                  {' ↔ '}
                  {AIRPORT_DB[dealB.destination]?.city ?? dealB.destination}
                </p>
                <p className="text-xs text-gray-500 mt-0.5">
                  {dealA.destination}–{dealB.destination} · {transportHint}
                </p>
              </div>
              <div className="shrink-0 text-right ml-3">
                <p className="font-bold text-teal-700">{formatDealPrice(combinedPrice).primary}</p>
                <p className="text-xs text-gray-400">combined</p>
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )
}
